import React, { useEffect, useState } from "react";
import "./style.css";
import {
  Container,
  ContainerTable,
  Menus,
  Table,
  Theader,
  Trbody,
  Td,
  Th,
  Title,
  Buttons,
  Colletion,
  Grup,
  DeleteButton,
  EditButton,
  ResetPassButton,
  AccessUserIcon,
} from "./style";
import Button from "../../Components/Button";
import { useFetcher, useNavigate } from "react-router-dom";
import Pesquisar from "../../Components/Pesquisar";
import CheckBox from "../../Components/Checkbox";
import api from "../../Services/api";
import { format } from "date-fns/esm";
import CriarUsario from "../../Components/modals/CriarUsuario";
import jwt_decode from "jwt-decode";
import { Alert, CloseAlert } from "../../utils/Alert";
import EditUsario from "../../Components/modals/EditUsuario";
import User from "../../Services/user";
import { AuthenticatorSec } from "../../auth";

export default function VisualizarUsuarios() {
  const Navigate = useNavigate();
  const [isActived, setIsActived] = useState(false);
  const [reload, setReload] = useState(false);
  const [isActivedEdit, setIsActivedEdit] = useState(false);
  const [usuario, setUsuario] = useState([]);
  const [Usuarios, setUsuarios] = useState([]);
  const [searchNome, setSearchNome] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [searchPerfil, setSearchPerfil] = useState("");
  const [mostrarTodos, setMostrarTodos] = useState(250);
  const [id_user] = useState(User.id());
  const [secretaria] = useState(User.perfil() === "secretaria");

  useEffect(() => {
    api
      .get("/usuario/listar?procurar")
      .then((res) => {
        setUsuarios(res.data);
        setMostrarTodos(res.data.length);
      })
      .catch((e) => {
        Alert({ tipo: "Error", mensagem: "Ocorreu um erro ao carregar os Usuários" });
      })
      .finally(() => {
        setReload(false);
      });
  }, [isActived, isActivedEdit, reload]);

  const normalizeString = (str) => {
    if (str === undefined || str === null) {
      return "";
    }
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredUsuarios = Usuarios?.filter((Usuarios) => {
    const searchNomeNormalized = normalizeString(searchNome);
    const searchEmailNormalized = normalizeString(searchEmail);
    const searchPerfilNormalized = normalizeString(searchPerfil);

    const UsuariosNome = normalizeString(Usuarios.nome || "");
    const UsuariosEmail = normalizeString(Usuarios.email || "");
    const UsuariosPerfil = normalizeString(Usuarios.perfil || "");

    return (
      UsuariosNome.includes(searchNomeNormalized) &&
      UsuariosEmail.includes(searchEmailNormalized) &&
      UsuariosPerfil.includes(searchPerfilNormalized)
    );
  }).slice(0, mostrarTodos);

  async function DeletarUsuario(id, nome) {
    try {
      Alert({ tipo: "Alert", mensagem: `Deseja deletar o Usuário ${nome}!` }).then((result) => {
        if (result.isConfirmed) {
          api
            .delete(`/usuario/apagar?id_usuario=${id}`)
            .then((result) => {
              window.location.reload();
            })
            .catch((err) => {
              console.log(err);
              Alert({ tipo: "Error", mensagem: "Ocorreu um erro ao desativar Usuário" });
            });
        }
      });
    } catch (err) {
      console.log(err);
      Alert({ tipo: "Error", mensagem: "Ocorreu um erro ao desativar Usuário" });
    }
  }

  async function RedefinirSenha(u) {
    try {
      Alert({ tipo: "Alert", mensagem: `Deseja redefinir a senha do usuário ${u.nome}!` }).then(async (result) => {
        if (result.isConfirmed) {
          Alert({ tipo: "Loading" });
          const res = await api.put(`/usuario/redefinir-senha`, u);
          await Alert({ tipo: "Sucesso2", mensagem: res.data.mensagem || "Senha redefinida com sucesso!" });
          setReload(true);
          CloseAlert();
        }
      });
    } catch (err) {
      CloseAlert();
      console.log(err);
      await Alert({ tipo: "Erro2", mensagem: err.response.data.erro || "Ocorreu um erro ao desativar Usuário" });
    }
  }
  async function accessUser(id, tipo) {
    const data = { id: id, accessUser: true, perfil: tipo };
    try {
      if (User.email() === "furgeri@gmail.com") {
        await api.patch(`/usuario/accessuser`, { data }).then((response) => {
          if (response.data.error) Alert("Erro-popup", "Não foi possível acessar o perfil!");

          localStorage.setItem("token", response.data.token);
          switch (tipo) {
            // case "secretaria":
            //   Navigate("/secretaria");
            //   break;
            case "coordenador":
              Navigate("/coordenador");
              break;
            case "professor":
              Navigate("/professor");
              break;
            default:
              break;
          }
        });
      }
    } catch (err) {
      Alert("Erro-popup", "Não foi possível acessar o perfil!");
    }
  }

  return (
    <>
      <CriarUsario isActived={isActived} setIsActived={setIsActived} />
      <EditUsario isActivedEdit={isActivedEdit} setIsActivedEdit={setIsActivedEdit} usuario={usuario} />
      <Container>
        <Menus>
          <Title>Controle de Usuarios</Title>
          <Buttons>
            <Button
              event={() => {
                const token = localStorage.getItem("token");
                const { perfil } = jwt_decode(token);
                return Navigate(perfil == "secretaria" ? "/secretaria" : "/coordenador");
              }}
              width="8rem"
              margintop="2%"
              placeholder="Voltar"
              backgroundcolor="#1a2e35"
              borderRadius="30px 30px 0px 0px"
            />
            <Button
              hidden={!secretaria}
              event={() => {
                setIsActived(true);
              }}
              width="10rem"
              margintop="2%"
              backgroundcolor="#1a2e35"
              placeholder="Adicionar"
              borderRadius="30px 30px 0px 0px"
            />
          </Buttons>
        </Menus>
        <ContainerTable>
          <Table>
            <Theader>
              <tr>
                <Th>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholdercolor="white"
                      placeholder="Digite nome"
                      name="nome"
                      event={(e) => {
                        setSearchNome(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholdercolor="white"
                      placeholder="Digite Email"
                      name="email"
                      event={(e) => {
                        setSearchEmail(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th>
                  <Grup>
                    <Pesquisar
                      color="white"
                      placeholdercolor="white"
                      placeholder="Digite Perfil"
                      name="email"
                      event={(e) => {
                        setSearchPerfil(e.target.value);
                      }}
                    />
                  </Grup>
                </Th>
                <Th className="m" hidden={!secretaria}></Th>
                <Th className="m" colSpan={!User.email() === "furgeri@gmail.com"  ? 2 : 3}>
                  {filteredUsuarios?.length} Usuarios
                </Th>
              </tr>
            </Theader>
            <tbody>
              {filteredUsuarios?.map((u, d) => (
                <Trbody
                  key={u.id}
                  style={
                    id_user !== u.id && !secretaria && (u.perfil === "secretaria" || u.perfil === "coordenador")
                      ? { opacity: 0.4 }
                      : {}
                  }
                >
                  <Td>{u?.nome}</Td>
                  <Td>{u?.email}</Td>
                  <Td>{u?.perfil}</Td>
                  {User.email() === "furgeri@gmail.com" && (
                    <Td className="center" hidden={!AuthenticatorSec()}>
                      <AccessUserIcon
                        onClick={() => u.perfil !== "DEV" && accessUser(u.id, u.perfil)}
                        title="Acessar Usuário"
                        disabled={u.perfil === "DEV"}
                      />
                    </Td>
                  )}
                  <Td className="m" hidden={!secretaria}>
                    <ResetPassButton
                      style={
                        id_user === u.id || (!secretaria && u.perfil === "secretaria")
                          ? { opacity: 0.4, cursor: "not-allowed" }
                          : {}
                      }
                      title={id_user === u.id ? "" : `Redefinir Senha do(a) ${u.nome}`}
                      onClick={() => {
                        if (id_user === u.id) {
                          return Alert({ tipo: "Alert3", mensagem: "Não é possível redefinir sua propria senha!" });
                        }
                        RedefinirSenha(u);
                      }}
                    />
                  </Td>
                  <Td className="m">
                    <EditButton
                      title="Editar Usuario"
                      style={
                        id_user !== u.id && !secretaria && (u.perfil === "secretaria" || u.perfil === "coordenador")
                          ? { cursor: "not-allowed", opacity: 0.4 }
                          : {}
                      }
                      onClick={() => {
                        if (
                          id_user !== u.id &&
                          !secretaria &&
                          (u.perfil === "secretaria" || u.perfil === "coordenador")
                        ) {
                          return Alert({ tipo: "Alert3", mensagem: "Você não tem permissão para editar essa conta!" });
                        }
                        setIsActivedEdit(true);
                        setUsuario(u);
                      }}
                    />
                  </Td>
                  <Td className="m">
                    <DeleteButton
                      title="Deletar Usuario"
                      style={
                        id_user === u.id || (!secretaria && (u.perfil === "secretaria" || u.perfil === "coordenador"))
                          ? { opacity: 0.4, cursor: "not-allowed" }
                          : {}
                      }
                      onClick={() => {
                        if (id_user === u.id) {
                          return Alert({ tipo: "Alert3", mensagem: "Não é possível deletar sua propria conta!" });
                        }
                        if (!secretaria && (u.perfil === "secretaria" || u.perfil === "coordenador")) {
                          return Alert({ tipo: "Alert3", mensagem: "Você não tem permissão para deletar essa conta!" });
                        }
                        DeletarUsuario(u?.id, u?.nome);
                      }}
                    />
                  </Td>
                </Trbody>
              ))}
            </tbody>
          </Table>
        </ContainerTable>
      </Container>
    </>
  );
}
